export default __webpack_public_path__ + "static/media/whatsapp.2c35d458.svg";